import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './auth0Provider';
import Toast from './Components/UI/Toast';
import AppRoutes from './Routes';
import { IReduxState } from './utils/types';
import { useEffect } from 'react';
// import { mainlogo } from '../src/Assets/Images/main-logo.png'


const App = () => {
  const ToastState = useSelector((state: IReduxState) => state.Toast);
  const AuthState = useSelector((state: IReduxState) => state.Auth);



  useEffect(() => {
    if (AuthState.controlium_type && AuthState.logo_folder) {
      document.title = AuthState.tenant_name;

      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link') as HTMLLinkElement;
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      
      link.href = 'favicon2.ico';
      // link.href = '%PUBLIC_URL%/favicon2.ico';
      // link.href = `../../src/Assets/Images/${AuthState.logo_folder}/mainLogo.png`;
    }else if(AuthState.role?.length>0){
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link') as HTMLLinkElement;
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      
      link.href = 'favicon.ico';
    }else{
      console.log(AuthState);
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link') as HTMLLinkElement;
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      
      link.href = 'favicon3.ico';
    }

  }, [AuthState]);

  return (
    <>
      <Toast
        show={ToastState.open}
        message={ToastState.message}
        severity={ToastState.severity}
      />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
